<template>
  <div class="timeslice-player" :style="{width: width, height: height}">
    <time-slice
      ref="timeslice"
      :timeslice-inicialization-data="timesliceRecorging.initData"
      :should-record="false"
    />
  </div>
</template>

<script>
  import TimeSlice from './TimeSlice';

  export default {
    name: 'TimeslicePlayer',
    components: {TimeSlice},
    props: {
      timesliceRecorging: {
        type: Object
      },
    },
    data: () => ({
      prevAction: null,
      timeoutNextAction: null,
      width: 0,
      height: 0
    }),

    methods: {
      startNextAction() {
        let nextAction = this.timesliceRecorging.records.shift();
        if(!nextAction) {
          return;
        }
        let timeTillNextAction = nextAction.timestamp - this.prevAction.timestamp;
        this.executeAction(this.prevAction);

        this.prevAction = nextAction;

        this.timeoutNextAction = setTimeout(() => {
          this.startNextAction();
        }, timeTillNextAction )
      },

      executeAction(action) {
        console.log('action.type', action.type);
        switch (action.type) {
          case 'undo':
            if(action.actor === 'user') {
              this.$refs.timeslice.undoUser();
            } else {
              this.$refs.timeslice.undo()
            }
            break;
          case 'clear':
            if(action.actor === 'user') {
              this.$refs.timeslice.clearUser();
            } else {
              this.$refs.timeslice.clear()
            }
            break;
          case 'arrow':
            if(action.actor === 'user') {
              this.$refs.timeslice.addUserArrow(action.arrowMatrix);
            } else {
              this.$refs.timeslice.addTechArrow(action.arrowMatrix)
            }
            break;
          case 'point':
            if(action.actor === 'user') {
              this.$refs.timeslice.mobileDraw(action.point);
            } else {
              this.$refs.timeslice.techDraw(action.point)
            }
            break;
          case 'stopDrawing':
            if(action.actor === 'user') {
              this.$refs.timeslice.stopDrawing();
            } else {
              this.$refs.timeslice.stopDrawingTech()
            }
            break;
        }
      }
    },

    mounted() {
      let nextAction = this.timesliceRecorging.records.shift();
      if(!nextAction) {
        return;
      }

      let timeTillNextAction = nextAction.timestamp - this.timesliceRecorging.initData.startedAt;
      this.prevAction = nextAction;
      setTimeout(() => {
        this.startNextAction()
      }, timeTillNextAction)
    },

    created() {
      this.width = this.timesliceRecorging.initData.width;
      this.height = this.timesliceRecorging.initData.height
    }
  }
</script>

<style lang="scss">
@import "TimeslicePlayer";
</style>
